import { z } from 'zod';
import { DataGridViewType, metricColoringValidator } from '@/features/DataGrid';
import type { Filters } from '@/features/filters';
import { filtersValidator } from '@/features/filters';
import type { SerializedDateRangeValueObject, Sorting } from '@/shared/types';
import {
  DateScale,
  columnsWidthStateValidator,
  serializedDateRangeValueObjectValidator,
  sortingValidator,
} from '@/shared/types';
import type { ParentGroup } from '../api/types';

export interface CalendarInsightsDataPage {
  rows: Record<string, string | number>[];
  hasNextPage: boolean;
}

export const dataConfigValidator = z.object({
  dimensions: z.array(z.string()),
  metrics: z.array(z.string()),
  cohortDateScale: z.enum(DateScale),
  cohortDateRange: serializedDateRangeValueObjectValidator,
  revenueDateScale: z.enum(DateScale),
  revenueDateRange: serializedDateRangeValueObjectValidator,
  sorting: sortingValidator,
  probabilisticAttribution: z.boolean(),
  filters: filtersValidator,
  rowHeight: z.number(),
  columnsWidth: columnsWidthStateValidator,
  metricsColoring: z.array(metricColoringValidator).optional(),
  dataGridViewType: z.enum(DataGridViewType),
});

export type DataConfig = z.infer<typeof dataConfigValidator>;

export interface GetDataParams {
  dimensions: string[];
  metrics: string[];
  cohortDateRange: SerializedDateRangeValueObject;
  cohortDateScale: DateScale;
  revenueDateRange: SerializedDateRangeValueObject;
  revenueDateScale: DateScale;
  sorting: Sorting;
  probabilisticAttribution: boolean;
  filters: Filters;
  offset?: number;
  pageSize?: number;
}
export interface GetMetricsMinMaxParams {
  dimensions: string[];
  metrics: string[];
  filters: Filters;
  cohortDateRange: SerializedDateRangeValueObject;
  cohortDateScale: DateScale;
  revenueDateRange: SerializedDateRangeValueObject;
  revenueDateScale: DateScale;
  probabilisticAttribution: boolean;
  dataGridViewType: DataGridViewType;
}

export interface GetTreeDataParams {
  dimensions: string[];
  metrics: string[];
  cohortDateScale: DateScale;
  cohortDateRange: SerializedDateRangeValueObject;
  revenueDateScale: DateScale;
  revenueDateRange: SerializedDateRangeValueObject;
  sorting: Sorting;
  probabilisticAttribution: boolean;
  filters: Filters;
  parentGroups: ParentGroup[];
}

export interface GetTotalParams {
  dimensions: string[];
  metrics: string[];
  cohortDateRange: SerializedDateRangeValueObject;
  revenueDateRange: SerializedDateRangeValueObject;
  probabilisticAttribution: boolean;
  filters: Filters;
}

export interface DataUpdateInfo {
  updateTime: string;
}
